import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Progress, Tooltip, Typography } from "antd";
import { Link } from "react-router-dom";
import { routesConfig } from "../../../config/routes";

const { Title, Text } = Typography;

interface IProps {
  minStudentData: any;
  handleChangeTab: () => any;
}
const MinStudentJoin = ({ minStudentData, handleChangeTab }: IProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <Flex className="mt-6 mb-[1rem]">
        <Text className="text-[1rem] pr-3">
          {t("Tiêu chí đánh giá số sinh viên tối thiểu tham gia buổi học", "Tiêu chí đánh giá số sinh viên tối thiểu tham gia buổi học")}
        </Text>
        <Tooltip
          title={
            <div>
              {t("Tiêu chí được thiết lập tại", "Tiêu chí được thiết lập tại")}{" "}
              <span onClick={handleChangeTab} className="text-[#1890FF] cursor-pointer">
                {t("Cài đặt kiểm soát chất lượng tiết học video", "Cài đặt kiểm soát chất lượng tiết học video")}
              </span>{" "}
            </div>
          }
        >
          <InfoCircleOutlined />
        </Tooltip>
      </Flex>
      <Flex justify="space-between" className="flex-wrap lg:!flex-nowrap">
        <div className="w-full lg:w-1/3 lg:mr-2 mb-6 lg:mb-0 bg-white">
          <div className="p-[24px] text-[1rem] font-medium">
            {t("Tiêu chí đánh giá", "Tiêu chí đánh giá")}
          </div>
          <Flex className="border-y">
            <div className="w-1/2 bg-[#FAFAFA] p-4 font-medium">
              {t("Số lượng tiêu chuẩn", "Số lượng tiêu chuẩn")}
            </div>
            <Flex className="w-1/2 p-4" justify="space-between">
              <Text>{minStudentData?.setting} {t("sinh viên", "sinh viên")}</Text>
              <Tooltip title={t("Số lượng sinh viên tối thiểu", "Số lượng sinh viên tối thiểu")}>
                <InfoCircleOutlined />
              </Tooltip>
            </Flex>
          </Flex>
          <Flex className="pt-6" justify="center">
            <Progress
              strokeLinecap="butt"
              type="dashboard"
              percent={(minStudentData?.total/minStudentData?.setting) * 100}
              className=""
              gapDegree={180}
              status="active"
              format={(percent) => (
                <div>
                  <div className="leading-0">
                    <Text className="leading-0 text-[2rem] font-medium">
                      {minStudentData?.total}
                    </Text>
                    <Text className="leading-0 text-[1rem] font-medium">
                      /{minStudentData?.setting}
                    </Text>
                  </div>
                  <div className="leading-0">
                    <Text className="leading-0 text-[1rem] font-normal">
                      {t("Thực tế", "Thực tế")}
                    </Text>
                    <Text className="leading-0 text-[1rem] font-normal">
                      {t("/Tiêu chí", "/Tiêu chí")}
                    </Text>
                  </div>
                </div>
              )}
              size={[200, 10]}
            />
          </Flex>
          <Flex className="border-y">
            <div className="w-1/2 bg-[#FAFAFA] p-4 font-medium">
              {t("Kết quả đánh giá", "Kết quả đánh giá")}
            </div>
            <Flex className="w-1/2 p-4" justify="space-between">
              {minStudentData?.total < minStudentData?.setting ? (
                <Text className="border border-[#FFA39E] text-[#F5222D] bg-[#FFF1F0] px-2 rounded-md">
                  {t("Không đạt", "Không đạt")}
                </Text>
              ) : (
                <Text className="border border-[#91D5FF] text-[#1677FF] bg-[#E6F7FF] px-2 rounded-md">
                  {t("Đạt", "Đạt")}
                </Text>
              )}
            </Flex>
          </Flex>
        </div>
        <div className="w-full lg:w-2/3 lg:ml-2 bg-white">
          <div className="p-[24px] text-[1rem] font-medium">
            {t("Thống kê chi tiết ( Tổng:", "Thống kê chi tiết ( Tổng:")} {minStudentData?.total} {t("sinh viên )", "sinh viên )")}
          </div>
          <div>
            <Flex className="bg-[#FAFAFA] py-4 border-t">
              <div className="px-4 w-1/2 font-medium">{t("Họ và tên", "Họ và tên")}</div>
              <div className="px-4 w-1/2 font-medium border-x">Email</div>
            </Flex>
            <div className="overflow-auto max-h-[265px]">
              {minStudentData?.details?.map(
                (value: { name: string; email: string }) => (
                  <Flex className="py-4 border-t">
                    <div className="px-4 w-1/2">{value?.name}</div>
                    <div className="px-4 w-1/2">{value?.email}</div>
                  </Flex>
                )
              )}
            </div>
          </div>
        </div>
      </Flex>
    </div>
  );
};

export default MinStudentJoin;
